// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2ebyv","featured":"featured__3wIuF","projects":"projects__ca4Ry"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/styles.scss
// module id = 246
// module chunks = 0